module.exports = __webpack_public_path__ + "static/media/OFmidterm_img.b4d32965.png";